import React from 'react';
import {Outlet} from "react-router-dom";
import './App.css';
import Header from './components/Header';
import Menu from './components/Menu';
import WelcomeBig from './components/WelcomeBig';
import Topics from './components/Topics';
import Areas from './components/Areas';
/* import Articles from './components/Articles'; */
import Port from './components/Port';
/* import Subscribe from './components/Subscribe'; */
import Footer from './components/Footer';



import AOS from "aos";
import "aos/dist/aos.css";

function Layout() {
  
    AOS.init();
  
  return (
    <>
      <Header />
      <Menu />
      <WelcomeBig />
      <Topics />
      <Areas />
      {/* <Articles /> */}
      <Port />
      {/* <Subscribe/> */}
      <Footer/>
      <Outlet />
    </>
  );
}

export default Layout;
